import { Injectable, inject } from '@angular/core';
import type { SafeResourceUrl } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class Jotform {
  private sanitizer = inject(DomSanitizer);

  getJotformUrl(formName: string, urlParams?: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      new URL(
        `https://form.jotform.com/freelancer_com/${formName}?${urlParams}`,
      ).toString(),
    );
  }
}
